/**
 * Adds table view utility methods
 */
export default {
	methods: {
		addColumns(columns, pos = -1) {
			this.visibleColumns.splice(pos, 0, ...columns)
		},
		removeColumns(columns) {
			this.visibleColumns = this.visibleColumns.filter((column) => {
				return !columns.includes(column);
			})
		},
		toggleColumns(columns, add = true, pos = -1) {
			this.removeColumns(columns);

			if(add) {
				this.addColumns(columns, pos);
			}
		},
		columnPosition(columnName) {
			return this.visibleColumns.findIndex(column => column === columnName)
		}
	}
}